import type { AppConfig } from "./interfaces";
import * as THREE from "three";

export class AudioManager {
  private camera: THREE.PerspectiveCamera;
  private config: AppConfig;
  private listener: THREE.AudioListener;
  private sound: THREE.Audio;
  private audioLoader: THREE.AudioLoader;
  private analyser!: THREE.AudioAnalyser;
  private audioReadyCallback?: () => void;

  constructor(camera: THREE.PerspectiveCamera, config: AppConfig) {
    this.camera = camera;
    this.config = config;
    this.listener = new THREE.AudioListener();
    this.camera.add(this.listener);
    this.sound = new THREE.Audio(this.listener);
    this.audioLoader = new THREE.AudioLoader();
  }

  public loadAudio(onReady?: () => void): void {
    this.audioReadyCallback = onReady;
    this.audioLoader.load(this.config.track, (buffer: AudioBuffer) => {
      this.sound.setBuffer(buffer);
      this.sound.setVolume(0.5);
      this.sound.setLoop(true);
      this.analyser = new THREE.AudioAnalyser(this.sound, this.config.fftSize);
      if (this.audioReadyCallback) {
        this.audioReadyCallback();
      }
    });
  }

  public play(): void {
    if (this.sound && !this.sound.isPlaying) {
      this.sound.play();
    }
  }

  public pause(): void {
    if (this.sound && this.sound.isPlaying) {
      this.sound.pause();
    }
  }

  public get isPlaying(): boolean {
    return this.sound ? this.sound.isPlaying : false;
  }

  public getAverageFrequency(): number {
    return this.analyser ? this.analyser.getAverageFrequency() : 0;
  }
}
